import {
  AttributeType,
  FieldType,
} from '../../../../../../../services/common/Constants';

import React from 'react';
import ListUnique from './listUnique';
import ListMultiple from './listMultiple';
import Numeric from './numeric';
import DateAttributeValue from './date';
import BooleanAttributeValue from './boolean';

const AttributeValue = ({
  selectedOperator,
  selectedFieldSubType,
  availableValueOptions,
  fieldName,
  showLabel,
  readOnly = false
}) => {
  switch (selectedFieldSubType) {
    case AttributeType.LIST_UNIQUE:
      return (
        <ListUnique
          selectedOperator={selectedOperator}
          availableValueOptions={availableValueOptions}
          fieldName={fieldName}
          showLabel={showLabel}
          readOnly={readOnly}
        />
      );
    case AttributeType.LIST_MULTIPLE:
      return (
        <ListMultiple
          selectedOperator={selectedOperator}
          availableValueOptions={availableValueOptions}
          fieldName={fieldName}
          showLabel={showLabel}
          readOnly={readOnly}
        />
      );
    case AttributeType.INTEGER:
    case AttributeType.DECIMAL:
    case AttributeType.PERCENTAGE:
      return (
        <Numeric
          selectedOperator={selectedOperator}
          availableValueOptions={availableValueOptions}
          fieldName={fieldName}
          showLabel={showLabel}
          selectedFieldSubType={selectedFieldSubType}
          readOnly={readOnly}
        />
      );
    case AttributeType.BOOLEAN:
      return <BooleanAttributeValue selectedOperator={selectedOperator} fieldName={fieldName} showLabel={showLabel} readOnly={readOnly}/>;
    case AttributeType.DATE:
    case FieldType.DATE:
      return (
        <DateAttributeValue
          selectedOperator={selectedOperator}
          fieldName={fieldName}
          showLabel={showLabel}
          readOnly={readOnly}
        />
      );

    default:
      break;
  }
};

export default AttributeValue;
